export function getDateMDYY(inputDateStr) {
    var date = new Date(inputDateStr);
    var retval = ''
    retval += date.getMonth() + 1;
    retval += '/' + date.getDate();
    retval += '/' + date.getFullYear().toString().substring(2, 4);
    return retval;
}


export function getDateMDYYYY(inputDateStr) {
    var date = new Date(inputDateStr);
    var retval = ''
    retval += date.getMonth() + 1;
    retval += '/' + date.getDate();
    retval += '/' + date.getFullYear();
    return retval;
}


export function getTimeShort(inputDateStr) {
    var date = new Date(inputDateStr);
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var retval = hours + ':' + minutes + ' ' + ampm;
    return retval;
}

export function getDateYYYYMMDD(inputDateStr) {
    var date = new Date(inputDateStr);
    var retval = '';
    retval += ('000' + (date.getFullYear())).slice(-4);
    retval += '-' + ('0' + (date.getMonth() + 1)).slice(-2);
    retval += '-' + ('0' + (date.getDate())).slice(-2);
    return retval;
}

export function getDateMMDDYYYY(inputDateStr) {
    var date = new Date(inputDateStr);
    var retval = '';
    retval += ('0' + (date.getMonth() + 1)).slice(-2);
    retval += '/' + ('0' + (date.getDate())).slice(-2);
    retval += '/' + date.getFullYear();
    return retval;
}

export function formatYYYYMMDDtoMMDDYYYY(inputDateStr) {
    // yyyy-mm-dd to mm/dd/yyyy
    var retval = '';
    retval += inputDateStr.slice(5, 7) + '/';
    retval += inputDateStr.slice(8, 10) + '/';
    retval += inputDateStr.slice(0, 4);
    return retval;
}

export function formatYYYYMMDDtoMMDDYYYYDash(inputDateStr) {
    // yyyy/mm/dd to mm-dd-yyyy
    var retval = '';
    retval += inputDateStr.slice(5, 7) + '-';
    retval += inputDateStr.slice(8, 10) + '-';
    retval += inputDateStr.slice(0, 4);
    return retval;
}


export function sortTimeOfDayHMMAA(a, b, order) {
    let sortMultiplier = order === 'asc' ? 1 : -1;
    return getMinutesHMMAA(a) > getMinutesHMMAA(b) ? sortMultiplier : -1 * sortMultiplier;
}

function getMinutesHMMAA(timeOfDay) {
    let hours = parseInt(timeOfDay.slice(0, timeOfDay.indexOf(":")));
    timeOfDay.endsWith("PM") && hours !== 12 ? hours += 12 : hours += 0;
    let minutes = parseInt(timeOfDay.slice(timeOfDay.indexOf(":") + 1, timeOfDay.indexOf(" ")));
    return ((hours * 60) + minutes);
}

export function sortDayOfWeek(a, b, order) {
    let sortMultiplier = order === 'asc' ? 1 : -1;
    return getDayOfWeekInt(a) > getDayOfWeekInt(b) ? sortMultiplier : -1 * sortMultiplier;
}

function getDayOfWeekInt(dow) {
    switch (dow) {
        case 'Sunday':
            return 0;
        case 'Monday':
            return 1;
        case 'Tuesday':
            return 2;
        case 'Wednesday':
            return 3;
        case 'Thursday':
            return 4;
        case 'Friday':
            return 5;
        case 'Saturday':
            return 6;
        default:
            return -1;
    }
}

export function sortDateTimeMDYYYYHMMMSSAA(a, b, order) {
    let sortMultiplier = order === 'asc' ? 1 : -1;
    return getDateMDYYYYHMMSSAA(a).getTime() > getDateMDYYYYHMMSSAA(b).getTime() ? sortMultiplier : -1 * sortMultiplier;
}

function getDateMDYYYYHMMSSAA(dateStr) {
    var date = new Date(dateStr.slice(0, dateStr.indexOf(' ')));
    var minutes = getMinutesHMMAA(dateStr.slice(dateStr.indexOf(' ') + 1));
    return new Date(date.getTime() + (minutes * 60 * 1000));

}

export function getAge(dateString) {
    var today = new Date();
    var birthDate = new Date(dateString);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return age;
}

export function fixCommas(str) {
    let temp = str;
    let commaCount = temp.split(',').length - 1;
    if (commaCount > 1) {
        let pos = temp.lastIndexOf(',');
        temp = temp.substring(0, pos) + ', and' + temp.substring(pos + 1);
    } else if (commaCount === 1) {
        let pos = temp.lastIndexOf(',');
        temp = temp.substring(0, pos) + ' and' + temp.substring(pos + 1);
    }
    return temp;
}
